import React, { PropTypes } from 'react';
import Portal from 'react-portal';

import { close, link, message } from './styles.module.css';

/**
 * Modal wrapper for charity information.
 */
const CharityModal = ({ content, title }) => (
  <Portal
    closeOnEsc
    closeOnOutsideClick
    openByClickOn={
      <a href="#charity" className={link}>
        {'More about this charity'}
      </a>
    }
  >
    <Modal title={title} content={content} />
  </Portal>
);

CharityModal.propTypes = {
  content: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

const Modal = ({ closePortal, title, content }) => (
  <div className="modal modal--form">
    <button className={close} type="button" onClick={closePortal} />
    <div className={message}>
      <h2 className={'charityName'}>{title}</h2>
      {/* eslint-disable react/no-danger */
        <div dangerouslySetInnerHTML={{ __html: content }} />
      /* eslint-disable */}
    </div>
  </div>
);

Modal.propTypes = {
  closePortal: PropTypes.func,
  content: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default CharityModal;



// WEBPACK FOOTER //
// ./app/src/components/EventTicketsPage/components/CharityModal/index.jsx